// import React, { useEffect, useState } from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   Radio,
//   RadioGroup,
//   FormControlLabel,
//   Button,
//   Grid,
//   Box,
//   Typography,
//   IconButton,
//   Switch,
//   FormGroup,
//   Tooltip,
//   tooltipClasses,
//   Table,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   Paper,
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import TextAreaComponents from "../../../../components/TextAreaComponents/TextAreaComponents.tsx";
// import AutoCompleteMultiSelect from "../../../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx";
// import { idID } from "@mui/material/locale";
// import AddSubOptionDialog from "./AddSubOption/AddSubOptionDialog.tsx";
// import axios from "axios";
// import { toast } from "react-toastify";
// import SweetAlertModal from "../../../../components/SweetAlertModal/SweetAlertModal.js";
// import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
// import { styled } from "@mui/material/styles";

// function AddOption(props) {
//   const apiAddress = process.env.REACT_APP_SECRET;
//   const Restauranttoken = JSON.parse(localStorage.getItem("restaurant"));
//   console.log(Restauranttoken.id);
//   const { open, onClose, onSave } = props;

//   const [nameOption, setNameOption] = useState("");
//   const [priceOption, setPriceOption] = useState(0.0);
//   const [vat, setVat] = useState(0);
//   const [sd, setSD] = useState(0);
//   const [percentage, setPercentage] = useState(0);
//   const [basePrice, setBasePrice] = useState(0);
//   const [sdPercentage, setSDPercentage] = useState(0);
//   const [InclusiveVat, setInclusiveVat] = useState();
//   const [MinQty, setMinQty] = useState();
//   const [MaxQty, setMaxQty] = useState();
//   const [subOptionId, setSubOptionId] = useState([]);

//   const [nameOptionErr, setNameOptionErr] = useState(false);
//   const [priceOptionErr, setPriceOptionErr] = useState(false);
//   const [vatErr, setVatErr] = useState(false);
//   const [InclusiveVatErr, setInclusiveVatErr] = useState(false);
//   const [MinQtyErr, setMinQtyErr] = useState(false);
//   const [MaxQtyErr, setMaxQtyErr] = useState(false);
//   const [MinQtyLimitErr, setMinQtyLimitErr] = useState(false);
//   const [MaxQtyLimitErr, setMaxQtyLimitErr] = useState(false);
//   const [openConfirmaitonModal, setopenConfirmaitonModal] = useState(false);

//   const [newInclusive, setNewInclusive] = useState(0);

//   function getPercentageOrAmount(amount1: number, amount2: number, mode: string): number | string {
//     if (mode === 'percentage') {
//       return (amount2 / amount1) * 100; // amount2 is what percentage of amount1
//     } else if (mode === 'amount') {
//       return (amount1 * amount2) / 100; // amount2% of amount1
//     } else {
//       return 'Invalid mode';
//     }
//   }

//   const handleClose = () => {
//     onClose();
//     props.reloadOption();
//   };

//   const [insertView, setinsertView] = useState({
//     AddOnOptionsMaster: {
//       Id: "123",
//     },
//   });

//   const PostOption = async (data) => {
//     var url = apiAddress + "/api/AddOnOptionsMaster/InsertAddOnOptionsMaster";
//     await axios.post(url, data).then((response) => {
//       toast.success("Successfully Saved", {
//         position: "top-right",
//         autoClose: 5000,
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//         progress: undefined,
//         theme: "colored",
//       });
//     });
//   };
//   const handleSave = async () => {
//     var valid = true;
//     if (!!nameOption == false) {
//       setNameOptionErr(true);
//       valid = false;
//     }
//     if (!!basePrice == false) {
//       setPriceOptionErr(true);
//       valid = false;
//     }
//     // if (!!vat == false) {
//     //   //setVatErr(true);
//     //   //valid = false;
//     // }
//     // if (!!InclusiveVat == false) {
//     //   setInclusiveVatErr(true);
//     //   valid = false;
//     // }

//     if(isCountable == true){

//       if (MinQty < 1) {
//         valid = false;
//       }
//       if (parseInt(MaxQty) < parseInt(MinQty)) {
//         valid = false;
//       }

//       if(!!MinQty == false){
//         valid = false;
//         toast.error("Min Qty is Required if IsCountable is on", {
//           position: "top-right",
//           autoClose: 5000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//           progress: undefined,
//           theme: "colored",
//         });
//       }
//       if(parseInt(MinQty) <= 0){
//         valid = false;
//         // toast.error("Min Qty Can not be 0 or less then 0", {
//         //   position: "top-right",
//         //   autoClose: 5000,
//         //   hideProgressBar: false,
//         //   closeOnClick: true,
//         //   pauseOnHover: true,
//         //   draggable: true,
//         //   progress: undefined,
//         //   theme: "colored",
//         // });
//       }
//       if(!!MaxQty == false){
//         valid = false;
//         toast.error("Max Qty is Required if IsCountable is on", {
//           position: "top-right",
//           autoClose: 5000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//           progress: undefined,
//           theme: "colored",
//         });
//       }
//       if(parseInt(MaxQty) <= 0){
//         valid = false;
//         // toast.error("Max Qty Can not be 0 or less then 0", {
//         //   position: "top-right",
//         //   autoClose: 5000,
//         //   hideProgressBar: false,
//         //   closeOnClick: true,
//         //   pauseOnHover: true,
//         //   draggable: true,
//         //   progress: undefined,
//         //   theme: "colored",
//         // });
//       }
//       if(!!increamentalQty == false){
//         valid = false;
//         toast.error("increamental Qty is Required if IsCountable is on", {
//           position: "top-right",
//           autoClose: 5000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//           progress: undefined,
//           theme: "colored",
//         });
//       }
//       if(parseInt(increamentalQty) <= 0){
//         valid = false;
//         // toast.error("Increament Qty Can not be 0 or less then 0", {
//         //   position: "top-right",
//         //   autoClose: 5000,
//         //   hideProgressBar: false,
//         //   closeOnClick: true,
//         //   pauseOnHover: true,
//         //   draggable: true,
//         //   progress: undefined,
//         //   theme: "colored",
//         // });
//       }
//       if(parseInt(increamentalQty)>parseInt(MaxQty)){
//         valid = false;
//         toast.error("Increament value Can not be more then Max Value", {
//           position: "top-right",
//           autoClose: 5000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//           progress: undefined,
//           theme: "colored",
//         });
//       }
//     }

//     //Option object
//     // AddOnOptionFormView.AddOnOptionsMaster.Id='123'
//     insertView.AddOnOptionsMaster.RestaurantId = Restauranttoken.id;
//     insertView.AddOnOptionsMaster.OptionName = nameOption;
//     insertView.AddOnOptionsMaster.BasePrice = basePrice;
//     insertView.AddOnOptionsMaster.VATinPercentage = percentage;
//     insertView.AddOnOptionsMaster.IsSubOption = switchCollapsableCheck;
//     insertView.AddOnOptionsMaster.CreationId = "123";
//     insertView.AddOnOptionsMaster.ModificationId = "123";
//     insertView.AddOnOptionsMaster.IsCountable = isCountable;
//     insertView.AddOnOptionsMaster.sDinPercentage = sdPercentage;
//     insertView.AddOnOptionsMaster.isSD = sdSwitch;

//     if(isCountable && MinQty === ""){
//       insertView.AddOnOptionsMaster.minQuantity = 0;
//     }
//     else if(isCountable){
//       insertView.AddOnOptionsMaster.minQuantity = MinQty ?? 0;
//     }
//     else if(MinQty === "" ){
//       insertView.AddOnOptionsMaster.minQuantity = 0
//     }
//     else{
//       insertView.AddOnOptionsMaster.minQuantity = MinQty ?? 0;
//     }

//     if(isCountable && MaxQty === ""){
//       insertView.AddOnOptionsMaster.maxQuantity = 100;
//     }
//     else if(isCountable){
//       insertView.AddOnOptionsMaster.maxQuantity = MaxQty ?? 100;
//     }
//     else if(MaxQty === ""){
//       insertView.AddOnOptionsMaster.maxQuantity = 0;
//     }
//     else{
//       insertView.AddOnOptionsMaster.maxQuantity = MaxQty ?? 0;
//     }

//     if(isCountable && increamentalQty === "" ){
//       insertView.AddOnOptionsMaster.incrementalQuantity = 1;
//     }
//     else if(isCountable){
//       insertView.AddOnOptionsMaster.incrementalQuantity = increamentalQty ?? 1;
//     }
//     else if(increamentalQty === ""){
//       insertView.AddOnOptionsMaster.incrementalQuantity = 1;
//     }
//     else{
//       insertView.AddOnOptionsMaster.incrementalQuantity = increamentalQty ?? 0;
//     }

//     //Option subOption mapper object
//     // insertView.OptionSubOptionMapperList.Id='123'
//     var mapperList = [];
//     subOptionId.map((d, i) => {
//       var obj = {
//         Id: "123",
//         OptionId: "123",
//         SubOptionId: d,
//         CreationId: "123",
//       };
//       mapperList.push(obj);
//     });
//     if (mapperList.length > 0) {
//       insertView.OptionSubOptionMapperList = mapperList;
//     }

//     var obj = {
//       Id: "string",
//       RestaurantId: "string",
//       SubOptionName: "string",
//       Price: 0,
//       CreationId: "string",
//       ModificationId: "string",
//     };
//     insertView.AddOnSubOptionsMasterList = [obj];

//     console.log("insert view: ", insertView);
//     if (valid) {
//       await PostOption(insertView);
//       setNameOption("");
//       setPriceOption("");
//       setVat("");
//       setInclusiveVat("");
//       setMinQty("");
//       setMaxQty("");
//       setswitchCollapsableCheck(false);
//       setSubOptionId([]);
//       setTempRowsData([]);
//       setRowsData([]);
//       handleClose();
//     }

//     setopenConfirmaitonModal(false);
//   };

//   const handleNameChange = (event) => {
//     setNameOption(event.target.value);
//     setNameOptionErr(false);
//   };

//   const handlePriceChange = (event) => {
//     setPriceOption(event.target.value);
//     setPriceOptionErr(false);
//   };

//   const updateVatdataFunction = props.AddOptionVatCheck;
//   const VATChange = (props) => {
//     const vatAmount = props.target.value;
//     setVat(vatAmount);
//     var vat = (parseFloat(vatAmount) / 100) * parseFloat(priceOption);
//     var priceIncludingVat = parseFloat(priceOption) + vat;
//     setInclusiveVat(priceIncludingVat);
//     setVatErr(false);
//     updateVatdataFunction(vatAmount);

//     const value = getPercentageOrAmount(parseFloat(basePrice), parseFloat(vatAmount), "percentage").toFixed(2);
//     if (!isNaN(value)) {
//       setPercentage(value);
//     }
//   };

//   const VATPercentageChange = (props) => {
//     const vatPercentage = props.target.value;
//     setPercentage(vatPercentage);

//     const value = getPercentageOrAmount(parseFloat(basePrice), parseFloat(vatPercentage), "amount").toFixed(2);
//     if (!isNaN(value)) {
//       setVat(value);
//     }
//   }

//   useEffect(() => {
//     if (basePrice && vat && sd) {
//       const value = handleInclusive([basePrice, vat.toString(), sd.toString()])
//       console.log("base price: ", value);
//       setNewInclusive(value);
//     } else {
//       setNewInclusive(0)
//     }
//   }, [basePrice, vat, sd])

//   const handleBasePrice = (props) => {
//     setBasePrice(props);
//   }

//   const handleInclusive = (amountArray: number[]) => {
//     const isListOfString = Array.isArray(amountArray) && amountArray.every(item => typeof item === 'string');

//     if (isListOfString) {
//       const newArray = amountArray.map((item) => parseFloat(item))
//       return newArray.reduce((accumulator, currentValue) => accumulator + currentValue, 0.0);
//     }
//     return 0;
//   };

//   const SDChange = (props) => {
//     const sdAmount = props.target.value;
//     setSD(sdAmount);

//     const value = getPercentageOrAmount(parseFloat(basePrice), parseFloat(sdAmount), "percentage").toFixed(2);
//     if (value) {
//       setSDPercentage(value);
//     }
//   };

//   const handleSetSDPercentage = (props) => {
//     const sdPercentage = props.target.value;
//     setSDPercentage(sdPercentage);

//     const value = getPercentageOrAmount(parseFloat(basePrice), parseFloat(sdPercentage), "amount").toFixed(2);

//     if (value) {
//       setSD(value);
//     }
//   };

//   const InclusiveVatChange = (props) => {
//     setInclusiveVat(props);
//     setInclusiveVatErr(false);
//   };

//   useEffect(() => {
//     InclusiveVatChange(newInclusive)
//   }, [newInclusive])

//   const MinQtyChange = (props) => {
//     console.log(props)
//     if (props <= 0) {
//       setMinQtyLimitErr(true);
//     } else {
//       setMinQtyLimitErr(false);
//     }
//     setMinQty(props);
//     setMinQtyErr(false);
//   };
//   const MaxQtyChange = (props) => {
//     if (props < MinQty) {
//       setMaxQtyLimitErr(true);
//     } else {
//       setMaxQtyLimitErr(false);
//     }
//     setMaxQty(props);
//     setMaxQtyErr(false);
//   };
//   const textFieldValue = (props) => {
//     console.log(props);
//     setPriceOption(props);
//     setPriceOptionErr(false);
//   };

//   const [increamentalQty, setIncreamentalQty] = useState();
//   const handelincreamentalQty = (e) => {
//     setIncreamentalQty(e);
//   };

//   //tooltip start
//   const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
//     <Tooltip {...props} classes={{ popper: className }} />
//   ))(({ theme }) => ({
//     [`& .${tooltipClasses.tooltip}`]: {
//       backgroundColor: "#f5f5f9",
//       color: "rgba(0, 0, 0, 0.87)",
//       maxWidth: 320,
//       fontSize: theme.typography.pxToRem(12),
//       border: "1px solid #dadde9",
//     },
//   }));

//   const [switchCollapsableCheck, setswitchCollapsableCheck] = useState(false);
//   const handleswitchCollapsableCheck = () => {
//     setswitchCollapsableCheck(!switchCollapsableCheck);
//   };

//   const [isCountable, setIsCountable] = useState(false);

//   const handleIsCountableCheck = () => {
//     if(isCountable == true){
//       setIsCountable(false)
//       if(!!MinQty != false){
//         setMinQty('')
//         //setMinQtyLimitErr(false)
//       }
//       if(!!MaxQty != false){
//         setMaxQty('')
//         //setMaxQtyLimitErr(false)
//       }
//       if(!!increamentalQty != false){
//         setIncreamentalQty('')
//         //setincreamentalLimitErr(false)
//         //setincreamentalOverLimitErr(false)
//       }
//     }
//     else if(isCountable == false){
//       setIsCountable(true);
//     }
//     //setIsCountable(!isCountable);
//   };

//   const [option, setOption] = React.useState([]);

//   const [subOptionDatas, setSubOptionData] = useState([]);
//   const loadSubOptiondata = async () => {
//     axios
//       .get(
//         apiAddress +
//         "/api/AddOnSubOptionsMaster/GetAddOnSubOptionsMasterListByRestaurantId?restaurantId=" +
//         Restauranttoken.id
//       )
//       .then((response) => {
//         var list = [];
//         var subOptionList = [];
//         response.data.map((dt, i) => {
//           var obj = { id: dt.id, title: dt.subOptionName };
//           var obj2 = {
//             suboptionName: dt.subOptionName,
//             subBaseprice: dt.price,
//           };

//           list.push(obj);
//           subOptionList.push(obj2);
//         });
//         setSubOptionData(list);
//         setOption(subOptionList);
//       });
//   };

//   useEffect(() => {
//     loadSubOptiondata();
//   }, []);

//   const ReloadSuboption = () => {
//     loadSubOptiondata();
//   };

//   const [rowsData, setRowsData] = useState([]);
//   const [tempRowsData, setTempRowsData] = useState([]);

//   React.useEffect(() => {
//     setRowsData(tempRowsData);
//   }, [rowsData]);

//   const addValue = (props) => {
//     console.log(props);
//     var temp = [];
//     var idList = [];
//     props.map((data, index) => {
//       idList.push(data.id);
//       var d = option.find((x) => x.suboptionName === data.title);
//       if (d != undefined) {
//         temp.push(d);
//       }
//     });
//     setSubOptionId(idList);
//     setTempRowsData(temp);
//     setRowsData([]);
//     // setAutoCompleteValue(props)
//   };
//   const [openAddSubOption, setOpenSubOption] = useState(false);
//   <h1> {props?.switchIsLinked}</h1>;
//   console.log("test1", props.switchIsLinked);


//   useEffect(() =>{
//     if(!!MinQty !=false || !!MaxQty !=false || !!increamentalQty !=false){
//       if(isCountable == false){
//         setIsCountable(true);
//       }else{
//         //setIsCountable(false);
//       }

//     }
//     else if( MinQty === 0 || MaxQty === 0 || increamentalQty === 0){
//       setIsCountable(false);
//     }
//     else{
//       setIsCountable(false);
//     }
//   },[MinQty,MaxQty,increamentalQty])

//   const [vatEnabled, setvatEnabled] = useState(true);
//   const [sdEnabled, setsdEnabled] = useState(true);
//   const [sdSwitch, setsdSwitch] = useState(false);
//   const [vatSwitch, setvatSwitch] = useState(false);

//   const handleVatSwitch = () => {
//     if(vatSwitch == false){
//       setvatSwitch(true)
//       setvatEnabled(false)
//     }
//     else{
//       setvatSwitch(false)
//       setvatEnabled(true)
//     }
//   }
//   const handleSDSwitch = () => {
//     if(sdSwitch == false){
//       setsdSwitch(true)
//       setsdEnabled(false)
//     }
//     else{
//       setsdSwitch(false)
//       setsdEnabled(true)
//     }
//   }

//   useEffect(() => {
//     const vatAM=  parseFloat(basePrice) * (parseFloat(percentage)/100)

//     const sdAM=  parseFloat(basePrice) * (parseFloat(sdPercentage)/100)

//     setVat(vatAM)
//     setSD(sdAM)

//     const value =  parseFloat(basePrice) + parseFloat(vat)  + parseFloat(sd) 
//     setNewInclusive(value)
//   }, [basePrice])

//   useEffect(() => { 
//     const value =  parseFloat(basePrice) + parseFloat(vat)  + parseFloat(sd) 
//     setNewInclusive(value)
//   }, [vat])

//   useEffect(() => {
//     const value =  parseFloat(basePrice) + parseFloat(vat)  + parseFloat(sd) 
//     setNewInclusive(value)
//   }, [sd])

//   return (
//     <Dialog
//       open={open}
//       onClose={handleClose}
//       className="specificationDialog specificationOptionDialog"
//       fullWidth={true}
//       maxWidth={"lg"}
//     >
//       <SweetAlertModal
//         headerText={"Are you sure?"}
//         bodyText={"You want to save this?"}
//         open={openConfirmaitonModal}
//         onyes={handleSave}
//         close={() => {
//           setopenConfirmaitonModal(false);
//         }}
//       />
//       <DialogTitle>
//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//           }}
//         >
//           <Typography variant="h6" className="textColor">
//             Add Option
//           </Typography>
//           <h1> {props?.switchIsLinked}</h1>
//           <IconButton
//             aria-label="close"
//             className="closeButton"
//             onClick={handleClose}
//           >
//             <CloseIcon />
//           </IconButton>
//         </Box>
//       </DialogTitle>
//       <DialogContent className="textColor">
//         <Grid
//           container
//           className="gridSpecificationContainer"
//           spacing={3}
//           alignItems="center"
//         >
//           <Grid item xs={3}>
//             <Typography className="textColor">Name</Typography>
//           </Grid>

//           <Grid item xs={9}>
//             <TextField
//               label="Name"
//               value={nameOption}
//               onChange={handleNameChange}
//               fullWidth
//               margin="normal"
//               InputLabelProps={{ sx: { color: "#371B17" } }}
//             />
//             {nameOptionErr && (
//               <span style={{ color: "red" }}>This field is required</span>
//             )}
//           </Grid>
//         </Grid>
//         <Grid
//           container
//           className="gridSpecificationContainer"
//           spacing={3}
//           alignItems="center"
//         >
//           <Grid item xs={3}>
//             <Typography className="textColor">Base Price</Typography>
//           </Grid>
//           <Grid item xs={9}>
//             <TextAreaComponents
//               label={"Base Price"}
//               value={handleBasePrice}
//               id={2}
//             />
//             {priceOptionErr && (
//               <span style={{ color: "red" }}>This field is required</span>
//             )}
//           </Grid>
//         </Grid>
//         <Grid
//           container
//           className="gridSpecificationContainer"
//           spacing={3}
//           alignItems="center"
//         >
//           <Grid item xs={3}>
//             <Typography className="textColor">VAT</Typography>
//           </Grid>
//           <Grid container item xs={9} direction="row" spacing={2}>
//           <Grid item xs={5.5}>
//               <TextField
//                 placeholder={"VAT percentage"}
//                 onChange={(e) => { VATPercentageChange(e) }}
//                 value={percentage}
//                 fullWidth
//                 type="number"
//               />

//               {props?.isVatAddedSpecificationPage === true ? (
//                 <span style={{ color: "red" }}>Vat Added in Add on Page</span>
//               ) : (
//                 ""
//               )}

//               {vatErr && (
//                 <span style={{ color: "red" }}>This field is required</span>
//               )}
//           </Grid>
//           <Grid item xs={0.5}>
//             <p> % </p>
//           </Grid>
//             <Grid item xs={6}>
//               <TextField
//                 placeholder={"VAT amount"}
//                 onChange={(e) => { VATChange(e) }}
//                 value={vat}
//                 type="number"
//                 fullWidth
//               />

//               {props?.isVatAddedSpecificationPage === true ? (
//                 <span style={{ color: "red" }}>Vat Added in Add on Page</span>
//               ) : (
//                 ""
//               )}

//               {vatErr && (
//                 <span style={{ color: "red" }}>This field is required</span>
//               )}
//             </Grid>
//           </Grid>
//         </Grid>

//         <Grid
//           container
//           className="gridSpecificationContainer"
//           spacing={3}
//           alignItems="center"
//         >
//           <Grid item xs={3}>
//             <Typography className="textColor">SD</Typography>
//           </Grid>
//           <Grid container item xs={9} direction="row" spacing={2}>
//           <Grid item xs={1} style={{ paddingTop: "1.5rem" }}>
//             <Switch
//               checked={sdSwitch}
//               onChange={handleSDSwitch}
//               inputProps={{ "aria-label": "controlled" }}
//               //disabled={isCountableActive}
//             />
//             </Grid>
//             <Grid item xs={4.5}>
//               <TextField
//                 placeholder={"SD percentage"}
//                 onChange={(e) => { handleSetSDPercentage(e) }}
//                 value={sdPercentage}
//                 fullWidth
//                 type="number"
//                 disabled={sdEnabled}
//               />

//               {props?.isVatAddedSpecificationPage === true ? (
//                 <span style={{ color: "red" }}>SD Added in Add on Page</span>
//               ) : (
//                 ""
//               )}

//               {vatErr && (
//                 <span style={{ color: "red" }}>This field is required</span>
//               )}
//             </Grid>
//             <Grid item xs={0.5} style={{ paddingTop: "2rem", gap:"0.2rem" }} display={"flex"}>
//               <p> % </p>
//               <p> </p>
//               <p> = </p>
//             </Grid>
//             <Grid item xs={6}>
//               <TextField
//                 placeholder={"SD amount"}
//                 onChange={(e) => { SDChange(e) }}
//                 value={sd}
//                 fullWidth
//                 type="number"
//                 disabled={sdEnabled}
//               />

//               {props?.isVatAddedSpecificationPage === true ? (
//                 <span style={{ color: "red" }}>SD Added in Add on Page</span>
//               ) : (
//                 ""
//               )}

//               {vatErr && (
//                 <span style={{ color: "red" }}>This field is required</span>
//               )}
//             </Grid>
//           </Grid>
//         </Grid>
//         <Grid
//           container
//           className="gridSpecificationContainer"
//           spacing={3}
//           alignItems="center"
//         >
//           <Grid item xs={3}>
//             <Typography className="textColor">Inclusive</Typography>
//           </Grid>
//           <Grid item xs={9}>
//             <TextAreaComponents
//               label={"Inclusive"}
//               value={InclusiveVatChange}
//               id={2}
//               val={newInclusive}
//             />
//             {InclusiveVatErr && (
//               <span style={{ color: "red" }}>This field is required</span>
//             )}
//           </Grid>
//         </Grid>
//         <Grid
//           container
//           className="gridSpecificationContainer"
//           spacing={3}
//           alignItems="center"
//         >
//           <Grid item xs={3}>
//             <Typography className="textColor">
//               Is countable
//             </Typography>
//           </Grid>
//           <Grid item xs={9}>
//             <Switch
//               inputProps={{ "aria-label": "controlled" }}
//               checked={isCountable}
//               onChange={handleIsCountableCheck}
//             />
//             <HtmlTooltip
//               title={
//                 <React.Fragment>
//                   <Typography color="inherit">
//                     Check this if your item is countable
//                   </Typography>
//                 </React.Fragment>
//               }
//             >
//               <InfoOutlinedIcon style={{ color: "#371B17" }} />
//             </HtmlTooltip>
//           </Grid>
//         </Grid>

//         {/* {props?.switchQuantityCheck ? (
//           <> */}
//         <Grid
//           container
//           className="gridSpecificationContainer"
//           spacing={3}
//           alignItems="center"
//         >
//           <Grid item xs={3}>
//             <Typography className="textColor">Min Qty</Typography>
//           </Grid>
//           <Grid item xs={9}>
//             <TextAreaComponents
//               label={"Min Qty"}
//               value={MinQtyChange}
//               id={2}
//               val={MinQty}
//             />
//             {MinQtyErr && (
//               <span style={{ color: "red" }}>This field is required</span>
//             )}
//             {MinQtyLimitErr && (
//               <span style={{ color: "red" }}>
//                 Min quantity must be 1 or more
//               </span>
//             )}
//           </Grid>
//         </Grid>
//         <Grid
//           container
//           className="gridSpecificationContainer"
//           spacing={3}
//           alignItems="center"
//         >
//           <Grid item xs={3}>
//             <Typography className="textColor">Max Qty</Typography>
//           </Grid>
//           <Grid item xs={9}>
//             <TextAreaComponents
//               label={"Max Qty"}
//               value={MaxQtyChange}
//               id={2}
//               val={MaxQty}
//             />
//             {MaxQtyErr && (
//               <span style={{ color: "red" }}>This field is required</span>
//             )}
//             {MaxQtyLimitErr && (
//               <span style={{ color: "red" }}>
//                 Max quantity must be equal or more than min quantity
//               </span>
//             )}
//           </Grid>
//         </Grid>
//         <Grid
//           container
//           className="gridSpecificationContainer"
//           spacing={3}
//           alignItems="center"
//         >
//           <Grid item xs={3}>
//             <Typography className="textColor">
//               Increamental Qty
//             </Typography>
//             <HtmlTooltip
//               title={
//                 <React.Fragment>
//                   <Typography color="inherit">
//                     Set the amount by which to increment the order
//                     quantity. For example, if the current quantity is 1
//                     and the user clicks on the + sign to increment it,
//                     and the minimum increment is 3, the quantity will
//                     increase by 3 and be set to 4 and so on
//                   </Typography>
//                 </React.Fragment>
//               }
//             >
//               <InfoOutlinedIcon style={{ color: "#371B17" }} />
//             </HtmlTooltip>
//           </Grid>
//           <Grid item xs={9}>
//             <TextAreaComponents
//               label={"Increamental Qty"}
//               value={handelincreamentalQty}
//               val={increamentalQty}
//               id={2}
//             />

//             {/* {MaxQtyErr && <span style={{ color: 'red' }}>This field is required</span>}
//                   {MaxQtyLimitErr && <span style={{ color: 'red' }}>Max quantity must be equal or more than min quantity</span>} */}
//           </Grid>
//         </Grid>
//         <Grid
//           container
//           className="gridSpecificationContainer"
//           spacing={3}
//           alignItems="center"
//         >
//           <Grid item xs={3}>
//             <Typography className="textColor">Sub Option</Typography>
//           </Grid>
//           <Grid item xs={9}>
//             <Switch
//               checked={switchCollapsableCheck}
//               onChange={handleswitchCollapsableCheck}
//               inputProps={{ "aria-label": "controlled" }}
//             />
//           </Grid>
//         </Grid>
//         {switchCollapsableCheck ? (
//           <>
//             <Grid
//               container
//               className="gridSpecificationContainer"
//               spacing={3}
//               alignItems="center"
//             >
//               <Grid item xs={3}></Grid>
//               <Grid item xs={9}>
//                 <Grid container sx={{ alignItems: "center" }} spacing={3}>
//                   <Grid item xs={9}>
//                     <AutoCompleteMultiSelect
//                       label={""}
//                       placeholder={"Sub Option"}
//                       value={addValue}
//                       datas={subOptionDatas}
//                       id={2}
//                     />
//                   </Grid>
//                   <Grid item xs={3}>
//                     <Button
//                       onClick={() => {
//                         setOpenSubOption(true);
//                       }}
//                     >
//                       + Add Sub Option
//                     </Button>
//                   </Grid>
//                 </Grid>
//               </Grid>
//             </Grid>
//             <Grid
//               container
//               className="gridSpecificationContainer"
//               spacing={3}
//               alignItems="center"
//             >
//               <Grid item xs={3}></Grid>
//               <Grid item xs={9}>
//                 <TableContainer component={Paper}>
//                   <Table aria-label="collapsible table">
//                     <TableHead>
//                       <TableRow>
//                         <TableCell>Name</TableCell>
//                         <TableCell align="right">Price</TableCell>
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {rowsData.map((row) => (
//                         <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
//                           <TableCell component="th" scope="row">
//                             {row.suboptionName}
//                           </TableCell>
//                           <TableCell align="right">
//                             {row.subBaseprice}
//                           </TableCell>
//                         </TableRow>
//                       ))}
//                     </TableBody>
//                   </Table>
//                 </TableContainer>
//               </Grid>
//             </Grid>
//           </>
//         ) : (
//           ""
//         )}
//       </DialogContent>
//       <DialogActions>
//         <Button
//           onClick={() => setopenConfirmaitonModal(true)}
//           className="textColor btn"
//         >
//           Save
//         </Button>
//       </DialogActions>
//       <AddSubOptionDialog
//         open={openAddSubOption}
//         onClose={() => setOpenSubOption(false)}
//         reloadSuboption={ReloadSuboption}
//       />
//     </Dialog>
//   );
// }

// export default AddOption;








import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  Button,
  Grid,
  Box,
  Typography,
  IconButton,
  Switch,
  FormGroup,
  Tooltip,
  tooltipClasses,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Autocomplete,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import TextAreaComponents from "../../../../components/TextAreaComponents/TextAreaComponents.tsx";
import AutoCompleteMultiSelect from "../../../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx";
import { idID } from "@mui/material/locale";
import AddSubOptionDialog from "./AddSubOption/AddSubOptionDialog.tsx";
import axios from "axios";
import { toast } from "react-toastify";
import SweetAlertModal from "../../../../components/SweetAlertModal/SweetAlertModal.js";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { styled } from "@mui/material/styles";

function AddOption(props) {
  const apiAddress = process.env.REACT_APP_SECRET;
  const Restauranttoken = JSON.parse(localStorage.getItem("restaurant"));
  console.log(Restauranttoken.id);
  const { open, onClose, onSave } = props;

  const [nameOption, setNameOption] = useState("");
  const [priceOption, setPriceOption] = useState(0.0);
  const [vat, setVat] = useState(0);
  const [sd, setSD] = useState(0);
  const [percentage, setPercentage] = useState(0);
  const [basePrice, setBasePrice] = useState(0);
  const [sdPercentage, setSDPercentage] = useState(0);
  const [InclusiveVat, setInclusiveVat] = useState();
  const [MinQty, setMinQty] = useState();
  const [MaxQty, setMaxQty] = useState();
  const [subOptionId, setSubOptionId] = useState([]);

  const [nameOptionErr, setNameOptionErr] = useState(false);
  const [priceOptionErr, setPriceOptionErr] = useState(false);
  const [vatErr, setVatErr] = useState(false);
  const [InclusiveVatErr, setInclusiveVatErr] = useState(false);
  const [MinQtyErr, setMinQtyErr] = useState(false);
  const [MaxQtyErr, setMaxQtyErr] = useState(false);
  const [MinQtyLimitErr, setMinQtyLimitErr] = useState(false);
  const [MaxQtyLimitErr, setMaxQtyLimitErr] = useState(false);
  const [openConfirmaitonModal, setopenConfirmaitonModal] = useState(false);

  const [newInclusive, setNewInclusive] = useState(0);

  function getPercentageOrAmount(amount1: number, amount2: number, mode: string): number | string {
    if (mode === 'percentage') {
      return (amount2 / amount1) * 100; // amount2 is what percentage of amount1
    } else if (mode === 'amount') {
      return (amount1 * amount2) / 100; // amount2% of amount1
    } else {
      return 'Invalid mode';
    }
  }

  const handleClose = () => {
    onClose();
    props.reloadOption();
  };

  const [insertView, setinsertView] = useState({
    AddOnOptionsMaster: {
      Id: "123",
    },
  });

  const PostOption = async (data) => {
    var url = apiAddress + "/api/AddOnOptionsMaster/InsertAddOnOptionsMaster";
    await axios.post(url, data).then((response) => {
      toast.success("Successfully Saved", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    });
  };
  
  const handleSave = async () => {
    console.log("Save button clicked");
    var valid = true;
    if (!!nameOption == false) {
      setNameOptionErr(true);
      valid = false;
    }
    if (!!basePrice == false) {
      setPriceOptionErr(true);
      valid = false;
    }

    if(isCountable == true){
      if (MinQty < 1) {
        valid = false;
      }
      if (parseInt(MaxQty) < parseInt(MinQty)) {
        valid = false;
      }

      // if(!!MinQty == false){
      //   valid = false;
      //   toast.error("Min Qty is Required if IsCountable is on", {
      //     position: "top-right",
      //     autoClose: 5000,
      //     hideProgressBar: false,
      //     closeOnClick: true,
      //     pauseOnHover: true,
      //     draggable: true,
      //     progress: undefined,
      //     theme: "colored",
      //   });
      // }
      // if(parseInt(MinQty) <= 0){
      //   valid = false;
      // }
      // if(!!MaxQty == false){
      //   valid = false;
      //   toast.error("Max Qty is Required if IsCountable is on", {
      //     position: "top-right",
      //     autoClose: 5000,
      //     hideProgressBar: false,
      //     closeOnClick: true,
      //     pauseOnHover: true,
      //     draggable: true,
      //     progress: undefined,
      //     theme: "colored",
      //   });
      // }
      // if(parseInt(MaxQty) <= 0){
      //   valid = false;
      // }
      // if(!!increamentalQty == false){
      //   valid = false;
      //   toast.error("increamental Qty is Required if IsCountable is on", {
      //     position: "top-right",
      //     autoClose: 5000,
      //     hideProgressBar: false,
      //     closeOnClick: true,
      //     pauseOnHover: true,
      //     draggable: true,
      //     progress: undefined,
      //     theme: "colored",
      //   });
      // }
      if(parseInt(increamentalQty) <= 0){
        valid = false;
      }
      if(parseInt(increamentalQty)>parseInt(MaxQty)){
        valid = false;
        toast.error("Increament value Can not be more then Max Value", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    }

    let vatOnSdId;
  let vatOnSdPercentage;
  let sdId;
  let sdPercentage;
  let SDAmount;
  let VatOnSDAmount;


  if (radiovalueSD === 'auto') {
    sdId = sdAdded?.id;
    sdPercentage = null;
    SDAmount = SdAmount;
  } else if (radiovalueSD === 'Specify') {
    sdId = null;
    sdPercentage = parseFloat(SdInAmount);
    SDAmount = SdAmount;
  } else if (radiovalueSD === 'Fixed') {
    sdId = null;
    sdPercentage = null;
    SDAmount = SdAmount;
  }

  if (radiovalueVatonSD === 'auto') {
    vatOnSdId = vatOnSdAdded?.id;
    vatOnSdPercentage = null;
    VatOnSDAmount =VatOnSdAmount;
  } else if (radiovalueVatonSD === 'Specify') {
    vatOnSdId = null;
    vatOnSdPercentage = parseFloat(VatOnSdInAmount);
     VatOnSDAmount =VatOnSdAmount
  }



    //Option object
    insertView.AddOnOptionsMaster.RestaurantId = Restauranttoken.id;
    insertView.AddOnOptionsMaster.OptionName = nameOption;
    insertView.AddOnOptionsMaster.BasePrice = basePrice;
    insertView.AddOnOptionsMaster.VATinPercentage = percentage;
    insertView.AddOnOptionsMaster.IsSubOption = switchCollapsableCheck;
    insertView.AddOnOptionsMaster.CreationId = "123";
    insertView.AddOnOptionsMaster.ModificationId = "123";
    insertView.AddOnOptionsMaster.IsCountable = isCountable;
    
    insertView.AddOnOptionsMaster.isSD = sdSwitch;

    //insertView.AddOnOptionsMaster.SD = SdAmount;
    //insertView.AddOnOptionsMaster.VATOnSD = VatOnSdAmount;
    insertView.AddOnOptionsMaster.vatOnSDId = vatOnSdId;
    insertView.AddOnOptionsMaster.vatOnSDType = radiovalueVatonSD;
    insertView.AddOnOptionsMaster.sdId = sdId;
    insertView.AddOnOptionsMaster.sdType = radiovalueSD;
    insertView.AddOnOptionsMaster.sDinPercentage = sdPercentage;
    insertView.AddOnOptionsMaster.sdInAmount = SDAmount;
    insertView.AddOnOptionsMaster.vatOnSDPercentage = vatOnSdPercentage;
    insertView.AddOnOptionsMaster.vatOnSDInAmount = VatOnSDAmount;
    insertView.AddOnOptionsMaster.priceInclusiveVAT = newInclusive;

    if(isCountable && MinQty === ""){
      insertView.AddOnOptionsMaster.minQuantity = 0;
    }
    else if(isCountable){
      insertView.AddOnOptionsMaster.minQuantity = MinQty ?? 0;
    }
    else if(MinQty === "" ){
      insertView.AddOnOptionsMaster.minQuantity = 0
    }
    else{
      insertView.AddOnOptionsMaster.minQuantity = MinQty ?? 0;
    }

    if(isCountable && MaxQty === ""){
      insertView.AddOnOptionsMaster.maxQuantity = 999;
    }
    else if(isCountable){
      insertView.AddOnOptionsMaster.maxQuantity = MaxQty ?? 999;
    }
    else if(MaxQty === ""){
      insertView.AddOnOptionsMaster.maxQuantity = 0;
    }
    else{
      insertView.AddOnOptionsMaster.maxQuantity = MaxQty ?? 0;
    }

    if(isCountable && increamentalQty === "" ){
      insertView.AddOnOptionsMaster.incrementalQuantity = 1;
    }
    else if(isCountable){
      insertView.AddOnOptionsMaster.incrementalQuantity = increamentalQty ?? 1;
    }
    else if(increamentalQty === ""){
      insertView.AddOnOptionsMaster.incrementalQuantity = 1;
    }
    else{
      insertView.AddOnOptionsMaster.incrementalQuantity = increamentalQty ?? 0;
    }

    //Option subOption mapper object
    var mapperList = [];
    subOptionId.map((d, i) => {
      var obj = {
        Id: "123",
        OptionId: "123",
        SubOptionId: d,
        CreationId: "123",
      };
      mapperList.push(obj);
    });
    if (mapperList.length > 0) {
      insertView.OptionSubOptionMapperList = mapperList;
    }

    var obj = {
      Id: "string",
      RestaurantId: "string",
      SubOptionName: "string",
      Price: 0,
      CreationId: "string",
      ModificationId: "string",
    };
    insertView.AddOnSubOptionsMasterList = [obj];

    console.log("insert view: ", insertView);
    if (valid) {
      await PostOption(insertView);
      setNameOption("");
      setPriceOption("");
      setVat("");
      setInclusiveVat("");
      setMinQty("");
      setMaxQty("");
      setswitchCollapsableCheck(false);
      setSubOptionId([]);
      setTempRowsData([]);
      setRowsData([]);
      handleClose();
    }

    setopenConfirmaitonModal(false);
  };

  const handleNameChange = (event) => {
    setNameOption(event.target.value);
    setNameOptionErr(false);
  };

  const handlePriceChange = (event) => {
    setPriceOption(event.target.value);
    setPriceOptionErr(false);
  };

  const updateVatdataFunction = props.AddOptionVatCheck;
  const VATChange = (props) => {
    const vatAmount = props.target.value;
    setVat(vatAmount);
    var vat = (parseFloat(vatAmount) / 100) * parseFloat(priceOption);
    var priceIncludingVat = parseFloat(priceOption) + vat;
    setInclusiveVat(priceIncludingVat);
    setVatErr(false);
    updateVatdataFunction(vatAmount);

    const value = getPercentageOrAmount(parseFloat(basePrice), parseFloat(vatAmount), "percentage").toFixed(2);
    if (!isNaN(value)) {
      setPercentage(value);
    }
  };

  const VATPercentageChange = (props) => {
    const vatPercentage = props.target.value;
    setPercentage(vatPercentage);

    const value = getPercentageOrAmount(parseFloat(basePrice), parseFloat(vatPercentage), "amount").toFixed(2);
    if (!isNaN(value)) {
      setVat(value);
    }
  }

  const handleInclusive = (amountArray: number[]) => {
    const isListOfString = Array.isArray(amountArray) && amountArray.every(item => typeof item === 'string');

    if (isListOfString) {
      const newArray = amountArray.map((item) => parseFloat(item))
      return newArray.reduce((accumulator, currentValue) => accumulator + currentValue, 0.0);
    }
    return 0;
  };

  const MinQtyChange = (props) => {
    console.log(props)
    if (props <= 0) {
      setMinQtyLimitErr(true);
    } else {
      setMinQtyLimitErr(false);
    }
    setMinQty(props);
    setMinQtyErr(false);
  };
  
  const MaxQtyChange = (props) => {
    if (props < MinQty) {
      setMaxQtyLimitErr(true);
    } else {
      setMaxQtyLimitErr(false);
    }
    setMaxQty(props);
    setMaxQtyErr(false);
  };
  
  const textFieldValue = (props) => {
    console.log(props);
    setPriceOption(props);
    setPriceOptionErr(false);
  };

  const [increamentalQty, setIncreamentalQty] = useState();
  const handelincreamentalQty = (e) => {
    setIncreamentalQty(e);
  };

  //tooltip start
  const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#f5f5f9",
      color: "rgba(0, 0, 0, 0.87)",
      maxWidth: 320,
      fontSize: theme.typography.pxToRem(12),
      border: "1px solid #dadde9",
    },
  }));

  const [switchCollapsableCheck, setswitchCollapsableCheck] = useState(false);
  const handleswitchCollapsableCheck = () => {
    setswitchCollapsableCheck(!switchCollapsableCheck);
  };

  const [isCountable, setIsCountable] = useState(false);

  const handleIsCountableCheck = () => {
    if(isCountable == true){
      setIsCountable(false)
      if(!!MinQty != false){
        setMinQty('')
      }
      if(!!MaxQty != false){
        setMaxQty('')
      }
      if(!!increamentalQty != false){
        setIncreamentalQty('')
      }
    }
    else if(isCountable == false){
      setIsCountable(true);
    }
  };

  const [option, setOption] = React.useState([]);

  const [subOptionDatas, setSubOptionData] = useState([]);
  const loadSubOptiondata = async () => {
    axios
      .get(
        apiAddress +
        "/api/AddOnSubOptionsMaster/GetAddOnSubOptionsMasterListByRestaurantId?restaurantId=" +
        Restauranttoken.id
      )
      .then((response) => {
        var list = [];
        var subOptionList = [];
        response.data.map((dt, i) => {
          var obj = { id: dt.id, title: dt.subOptionName };
          var obj2 = {
            suboptionName: dt.subOptionName,
            subBaseprice: dt.price,
          };

          list.push(obj);
          subOptionList.push(obj2);
        });
        setSubOptionData(list);
        setOption(subOptionList);
      });
  };

  useEffect(() => {
    loadSubOptiondata();
  }, []);

  const ReloadSuboption = () => {
    loadSubOptiondata();
  };

  const [rowsData, setRowsData] = useState([]);
  const [tempRowsData, setTempRowsData] = useState([]);

  React.useEffect(() => {
    setRowsData(tempRowsData);
  }, [rowsData]);

  const addValue = (props) => {
    console.log(props);
    var temp = [];
    var idList = [];
    props.map((data, index) => {
      idList.push(data.id);
      var d = option.find((x) => x.suboptionName === data.title);
      if (d != undefined) {
        temp.push(d);
      }
    });
    setSubOptionId(idList);
    setTempRowsData(temp);
    setRowsData([]);
  };
  
  const [openAddSubOption, setOpenSubOption] = useState(false);
  
  useEffect(() =>{
    if(!!MinQty !=false || !!MaxQty !=false || !!increamentalQty !=false){
      if(isCountable == false){
        setIsCountable(true);
      }
    }
    else if( MinQty === 0 || MaxQty === 0 || increamentalQty === 0){
      setIsCountable(false);
    }
    else{
      setIsCountable(false);
    }
  },[MinQty,MaxQty,increamentalQty])

  const [vatEnabled, setvatEnabled] = useState(true);
  const [sdEnabled, setsdEnabled] = useState(true);
  const [sdSwitch, setsdSwitch] = useState(false);
  const [vatSwitch, setvatSwitch] = useState(false);

  const handleVatSwitch = () => {
    if(vatSwitch == false){
      setvatSwitch(true)
      setvatEnabled(false)
    }
    else{
      setvatSwitch(false)
      setvatEnabled(true)
    }
  }

  // SD and VAT on SD states
  const [radiovalueSD, setRadiovalueSD] = useState("auto");
  const [customSD, setCustomSD] = useState("");
  const [sdDatas, setsdDatas] = useState([]);
  const [sdAdded, setsdAdded] = useState(null);
  const [SdAmount, setSdAmount] = useState(0);
  const [SdInAmount, setSdInAmount] = useState(0.0);

  const [radiovalueVatonSD, setRadiovalueVatonSD] = useState("auto");
  const [customVatonSD, setCustomVatonSD] = useState("");
  const [vatOnSdAdded, setVatOnSdAdded] = useState(null);
  const [VatOnSdAmount, setVatOnSdAmount] = useState(0);
  const [VatOnSdInAmount, setVatOnSdInAmount] = useState(0.0);
  const [vatAmount, setVatAmount] = useState(0);
  const [vatOnSdId, setVatOnSdId] = useState(null);
const [vatOnSdType, setVatOnSdType] = useState(null);
const [sdType, setSdType] = useState(null);
const [sdId, setSdId] = useState(null);

console.log(VatOnSdInAmount);
console.log(VatOnSdAmount);
  // SD handlers
const handleRadioChangeSD = (event) => {
  const value = event.target.value;
  setRadiovalueSD(value);
  setSdType(value); // Set the SD type

  if (value === "Specify") {
    setsdAdded(null);
    setCustomSD("");
    setSdId(null);
    setSdAmount(0);
  } else if (value === "auto") {
    setCustomSD("");
    setSdId(sdAdded?.id || null);
    setSdAmount(0);
  } else if (value === "Fixed") {
    setSdAmount(0);
    setSdInAmount("");
    setSdId(null);
  }
};

  const inAmountSDValue = (props) => {
    if (radiovalueSD === "Fixed") {
      setSdAmount(props)
    }
  };

  const SDChange = (props) => {
    const sdAmount = props.target.value;
    setSD(sdAmount);

    const value = getPercentageOrAmount(parseFloat(basePrice), parseFloat(sdAmount), "percentage").toFixed(2);
    if (value) {
      setSDPercentage(value);
    }
  };

  const handleSetSDPercentage = (props) => {
    const sdPercentage = props.target.value;
    setSDPercentage(sdPercentage);

    const value = getPercentageOrAmount(parseFloat(basePrice), parseFloat(sdPercentage), "amount").toFixed(2);

    if (value) {
      setSD(value);
    }
  };

  // VAT on SD handlers
const handleRadioChangeVatOnSD = (event) => {
  const value = event.target.value;
  setRadiovalueVatonSD(value);
  setVatOnSdType(value); // Set the VAT on SD type

  if (value === "Specify") {
    setVatOnSdAdded(null);
    setCustomVatonSD("");
    setVatOnSdId(null);
  } else {
    setCustomVatonSD("");
    setVatOnSdId(vatOnSdAdded?.id || null);
  }
};

  const handleSDSwitch = () => {
    if(sdSwitch == false){
      setsdSwitch(true)
      setsdEnabled(false)
    }
    else{
      setsdSwitch(false)
      setsdEnabled(true)
    }
  }

  useEffect(() => {
    if (sdAdded && sdAdded.percentage) {
      setSdInAmount(sdAdded.percentage);

      var sdPrice = sdAdded.percentage / 100
      var total = sdPrice * basePrice;
      setSdAmount(total.toFixed(2));
    } else if (customSD) {
      setSdInAmount(customSD);
      var vatPrice = customSD / 100
      var total = vatPrice * basePrice;
      setSdAmount(total.toFixed(2));
    } else {
      setSdInAmount(0);
      setSdAmount(0);
    }
  }, [sdAdded, customSD]);

  useEffect(() => {
    if (vatOnSdAdded && vatOnSdAdded.percentage) {
      setVatOnSdInAmount(vatOnSdAdded.percentage);

      var sdPrice = vatOnSdAdded.percentage / 100
      var total = sdPrice * SdAmount;
      setVatOnSdAmount(total.toFixed(2));
    } else if (customVatonSD) {
      setVatOnSdInAmount(customVatonSD);
      var vatPrice = customVatonSD / 100
      var total = vatPrice * SdAmount;
      setVatOnSdAmount(total.toFixed(2));
    } else {
      setVatOnSdInAmount(0);
      setVatOnSdAmount(0);
    }
  }, [vatOnSdAdded, customVatonSD]);

  useEffect(() => {
    const vatAM = parseFloat(basePrice) * (parseFloat(percentage)/100)
    const sdAM = parseFloat(basePrice) * (parseFloat(sdPercentage)/100)
    const vatonsdAM = parseFloat(sdAM) * (parseFloat(VatOnSdInAmount)/100)

    setVat(vatAM.toFixed(2))
    setSD(sdAM.toFixed(2))
    setVatOnSdAmount(vatonsdAM.toFixed(2))

    const value = parseFloat(basePrice) + parseFloat(vat) + parseFloat(SdAmount) + parseFloat(VatOnSdAmount)
    setNewInclusive(value.toFixed(2))
  }, [basePrice])

  useEffect(() => { 
    const value = parseFloat(basePrice) + parseFloat(vat) + parseFloat(SdAmount) + parseFloat(VatOnSdAmount)
    setNewInclusive(value.toFixed(2))
  }, [vat])

  useEffect(() => {
    const value = parseFloat(basePrice) + parseFloat(vat) + parseFloat(SdAmount) + parseFloat(VatOnSdAmount)
    setNewInclusive(value.toFixed(2))
  }, [SdAmount])

  useEffect(() => {
    const value = parseFloat(basePrice) + parseFloat(vat) + parseFloat(SdAmount) + parseFloat(VatOnSdAmount)
    setNewInclusive(value.toFixed(2))
  }, [VatOnSdAmount])

  const InclusiveVatChange = (props) => {
    setInclusiveVat(props);
    setInclusiveVatErr(false);
  };

  useEffect(() => {
    InclusiveVatChange(newInclusive)
  }, [newInclusive])

  useEffect(() => {
    if (basePrice && vat && sd) {
      const value = handleInclusive([basePrice, vat.toString(), sd.toString()])
      console.log("base price: ", value);
      setNewInclusive(value);
    } else {
      setNewInclusive(0)
    }
  }, [basePrice, vat, sd])

  const handleBasePrice = (props) => {
    setBasePrice(props);
  }

  useEffect(() => {
    axios
      .get(
        apiAddress +
        "/api/Vat/GetAllVatListByRestaurantIdAsync?restaurantId=" + Restauranttoken?.id
      )
      .then((response) => {
        var list = [];
        response.data?.map((dt, i) => {
          var obj =
          {
            id: dt.id,
            title: dt.name,
            percentage: dt.percentage
          };
          list.push(obj);
        });
        setvatDatas(list);
      });
  }, []);

  const [vatDatas, setvatDatas] = useState([]);
  const [VatOnsdPercentage, setVatOnsdPercentage] = useState(0);
  const [isactive, setIsactive] = React.useState(false);
  const [VatOnsd, setVatOnsd] = useState(0);
  
  const inPercentageVATValue = (props) => {};
  const inAmountVATValue = (props) => {};

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      className="specificationDialog specificationOptionDialog"
      fullWidth={true}
      maxWidth={"lg"}
    >
      <SweetAlertModal
        headerText={"Are you sure?"}
        bodyText={"You want to save this?"}
        open={openConfirmaitonModal}
        onyes={handleSave}
        close={() => {
          setopenConfirmaitonModal(false);
        }}
      />
      <DialogTitle>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" className="textColor">
            Add Option
          </Typography>
          <h1> {props?.switchIsLinked}</h1>
          <IconButton
            aria-label="close"
            className="closeButton"
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent className="textColor">
        <Grid
          container
          className="gridSpecificationContainer"
          spacing={3}
          alignItems="center"
        >
          <Grid item xs={3}>
            <Typography className="textColor">Name</Typography>
          </Grid>

          <Grid item xs={9}>
            <TextField
              label="Name"
              value={nameOption}
              onChange={handleNameChange}
              fullWidth
              margin="normal"
              InputLabelProps={{ sx: { color: "#371B17" } }}
            />
            {nameOptionErr && (
              <span style={{ color: "red" }}>This field is required</span>
            )}
          </Grid>
        </Grid>
        <Grid
          container
          className="gridSpecificationContainer"
          spacing={3}
          alignItems="center"
        >
          <Grid item xs={3}>
            <Typography className="textColor">Base Price</Typography>
          </Grid>
          <Grid item xs={9}>
            <TextAreaComponents
              label={"Base Price"}
              value={handleBasePrice}
              id={2}
            />
            {priceOptionErr && (
              <span style={{ color: "red" }}>This field is required</span>
            )}
          </Grid>
        </Grid>
        <Grid
          container
          className="gridSpecificationContainer"
          spacing={3}
          alignItems="center"
        >
          <Grid item xs={3}>
            <Typography className="textColor">VAT</Typography>
          </Grid>
          <Grid container item xs={9} direction="row" spacing={2}>
          <Grid item xs={5.5}>
              <TextField
                placeholder={"VAT percentage"}
                onChange={(e) => { VATPercentageChange(e) }}
                value={percentage}
                fullWidth
                type="number"
              />

              {props?.isVatAddedSpecificationPage === true ? (
                <span style={{ color: "red" }}>Vat Added in Add on Page</span>
              ) : (
                ""
              )}

              {vatErr && (
                <span style={{ color: "red" }}>This field is required</span>
              )}
          </Grid>
          <Grid item xs={0.5}>
            <p> % </p>
          </Grid>
            <Grid item xs={6}>
              <TextField
                placeholder={"VAT amount"}
                onChange={(e) => { VATChange(e) }}
                value={vat}
                type="number"
                fullWidth
              />

              {props?.isVatAddedSpecificationPage === true ? (
                <span style={{ color: "red" }}>Vat Added in Add on Page</span>
              ) : (
                ""
              )}

              {vatErr && (
                <span style={{ color: "red" }}>This field is required</span>
              )}
            </Grid>
          </Grid>
        </Grid>

        {/* SD Section */}
        <Grid container className="gridSpecificationContainer" spacing={3} alignItems="center">
          <Grid item xs={3}>
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Typography className="textColor">SD</Typography>
              <Switch 
                checked={sdSwitch}
                onChange={handleSDSwitch}
                inputProps={{ "aria-label": "controlled" }}
              />
            </Box>
          </Grid>

          <Grid container item xs={9} direction="row" spacing={2}>
            <Grid item xs={12}>
              <RadioGroup
                row
                name="sd-radio-buttons-group"
                value={radiovalueSD}
                onChange={handleRadioChangeSD}
                disabled={sdEnabled}
              >
                <FormControlLabel value="auto" control={<Radio />} label="Select from SD List" />
                <span style={{ padding: "0.5rem" }}> - Or - </span>
                <FormControlLabel value="Specify" control={<Radio />} label="Specify SD" />
                <span style={{ padding: "0.5rem" }}> - Or - </span>
                <FormControlLabel value="Fixed" control={<Radio />} label="Fixed SD" />
              </RadioGroup>
            </Grid>

            {radiovalueSD === "auto" && (
              <Grid item xs={4}>
                <Autocomplete
                  id="free-solo-with-text-demo"
                  options={vatDatas}
                  value={sdAdded}
                  onChange={(event, newInputValue) => {
                    setsdAdded(newInputValue);
                    setSdId(newInputValue?.id || null); // Set the SD ID when selected
                  }}
                  getOptionLabel={(option) => option?.title || ""}
                  disabled={sdEnabled}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Select SD"
                    />
                  )}
                />
              </Grid>
            )}

            {radiovalueSD === "Specify" && (
              <Grid item xs={4}>
                <TextField
                  placeholder="Specify SD Percentage"
                  variant="outlined"
                  value={customSD}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "" || Number(value) >= 0) {
                      setCustomSD(value);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e") {
                      e.preventDefault();
                    }
                  }}
                  type="number"
                  disabled={sdEnabled}
                  fullWidth
                />
              </Grid>
            )}

            <Grid item xs={4}>
              <TextAreaComponents
                id={2}
                label="SD (%)"
                value={handleSetSDPercentage}
                val={SdInAmount !== 0 ? SdInAmount : ""}
                isactive={isactive}
                placeholder="SD (%)"
                disabled={sdEnabled}
              />
              {vatErr && <span style={{ color: "red" }}>This field is required</span>}
            </Grid>

            <Grid item xs={4}>
              <TextAreaComponents
                id={2}
                label="SD (Amount)"
                value={inAmountSDValue}
                val={SdAmount}
                isactive={isactive}
                disabled={sdEnabled}
              />
            </Grid>
          </Grid>
        </Grid>

        {/* VAT on SD Section */}
        <Grid container className="gridSpecificationContainer" spacing={3} alignItems="center">
          <Grid item xs={3}>
            <Typography className="textColor">VAT On SD</Typography>
          </Grid>
          <Grid container item xs={9} direction="row" spacing={2}>
            <Grid item xs={12}>
              <RadioGroup
                row
                name="vat-sd-radio-buttons-group"
                value={radiovalueVatonSD}
                onChange={handleRadioChangeVatOnSD}
                disabled={sdEnabled}
              >
                <FormControlLabel value="auto" control={<Radio />} label="Select from VAT List" />
                <span style={{ padding: "0.5rem" }}> - Or - </span>
                <FormControlLabel value="Specify" control={<Radio />} label="Specify VAT On SD" />
              </RadioGroup>
            </Grid>

            {radiovalueVatonSD === "auto" && (
              <Grid item xs={4}>
                <Autocomplete
                  id="select-vat"
                  options={vatDatas}
                  value={vatOnSdAdded}
                  onChange={(event, newInputValue) => {
                    setVatOnSdAdded(newInputValue);
                    setVatOnSdId(newInputValue?.id || null); // Set the VAT on SD ID when selected
                  }}
                  getOptionLabel={(option) => option?.title || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select VAT"
                      variant="outlined"
                      fullWidth
                      disabled={sdEnabled}
                    />
                  )}
                />
              </Grid>
            )}

            {radiovalueVatonSD === "Specify" && (
              <Grid item xs={4}>
                <TextField
                  placeholder="Specify VAT (%)"
                  variant="outlined"
                  value={customVatonSD}
                  type="number"
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "" || Number(value) >= 0) {
                      setCustomVatonSD(value);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "-" || e.key === "e") {
                      e.preventDefault();
                    }
                  }}
                  disabled={sdEnabled}
                  fullWidth
                />
              </Grid>
            )}

            <Grid item xs={4}>
              <TextAreaComponents
                id={2}
                label="VAT (%)"
                value={inPercentageVATValue}
                val={VatOnSdInAmount !== 0 ? VatOnSdInAmount : ""}
                isactive={isactive}
                placeholder="VAT (%)"
                disabled={sdEnabled}
              />
              {vatErr && <span style={{ color: "red" }}>This field is required</span>}
            </Grid>

            <Grid item xs={4}>
              <TextAreaComponents
                id={2}
                label="VAT (Amount)"
                value={inAmountVATValue}
                val={VatOnSdAmount}
                isactive={isactive}
                disabled={sdEnabled}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid
          container
          className="gridSpecificationContainer"
          spacing={3}
          alignItems="center"
        >
          <Grid item xs={3}>
            <Typography className="textColor">Inclusive</Typography>
          </Grid>
          <Grid item xs={9}>
            <TextAreaComponents
              label={"Inclusive"}
              value={InclusiveVatChange}
              id={2}
              val={newInclusive}
            />
            {InclusiveVatErr && (
              <span style={{ color: "red" }}>This field is required</span>
            )}
          </Grid>
        </Grid>
        <Grid
          container
          className="gridSpecificationContainer"
          spacing={3}
          alignItems="center"
        >
          <Grid item xs={3}>
            <Typography className="textColor">
              Is countable
            </Typography>
          </Grid>
          <Grid item xs={9}>
            <Switch
              inputProps={{ "aria-label": "controlled" }}
              checked={isCountable}
              onChange={handleIsCountableCheck}
            />
            <HtmlTooltip
              title={
                <React.Fragment>
                  <Typography color="inherit">
                    Check this if your item is countable
                  </Typography>
                </React.Fragment>
              }
            >
              <InfoOutlinedIcon style={{ color: "#371B17" }} />
            </HtmlTooltip>
          </Grid>
        </Grid>

        <Grid
          container
          className="gridSpecificationContainer"
          spacing={3}
          alignItems="center"
        >
          <Grid item xs={3}>
            <Typography className="textColor">Min Qty</Typography>
          </Grid>
          <Grid item xs={9}>
            <TextAreaComponents
              label={"Min Qty"}
              value={MinQtyChange}
              id={2}
              val={MinQty}
            />
            {MinQtyErr && (
              <span style={{ color: "red" }}>This field is required</span>
            )}
            {MinQtyLimitErr && (
              <span style={{ color: "red" }}>
                Min quantity must be 1 or more
              </span>
            )}
          </Grid>
        </Grid>
        <Grid
          container
          className="gridSpecificationContainer"
          spacing={3}
          alignItems="center"
        >
          <Grid item xs={3}>
            <Typography className="textColor">Max Qty</Typography>
          </Grid>
          <Grid item xs={9}>
            <TextAreaComponents
              label={"Max Qty"}
              value={MaxQtyChange}
              id={2}
              val={MaxQty}
            />
            {MaxQtyErr && (
              <span style={{ color: "red" }}>This field is required</span>
            )}
            {MaxQtyLimitErr && (
              <span style={{ color: "red" }}>
                Max quantity must be equal or more than min quantity
              </span>
            )}
          </Grid>
        </Grid>
        <Grid
          container
          className="gridSpecificationContainer"
          spacing={3}
          alignItems="center"
        >
          <Grid item xs={3}>
            <Typography className="textColor">
              Increamental Qty
            </Typography>
            <HtmlTooltip
              title={
                <React.Fragment>
                  <Typography color="inherit">
                    Set the amount by which to increment the order
                    quantity. For example, if the current quantity is 1
                    and the user clicks on the + sign to increment it,
                    and the minimum increment is 3, the quantity will
                    increase by 3 and be set to 4 and so on
                  </Typography>
                </React.Fragment>
              }
            >
              <InfoOutlinedIcon style={{ color: "#371B17" }} />
            </HtmlTooltip>
          </Grid>
          <Grid item xs={9}>
            <TextAreaComponents
              label={"Increamental Qty"}
              value={handelincreamentalQty}
              val={increamentalQty}
              id={2}
            />

            {/* {MaxQtyErr && <span style={{ color: 'red' }}>This field is required</span>}
                  {MaxQtyLimitErr && <span style={{ color: 'red' }}>Max quantity must be equal or more than min quantity</span>} */}
          </Grid>
        </Grid>

                <Grid
          container
          className="gridSpecificationContainer"
          spacing={3}
          alignItems="center"
        >
          <Grid item xs={3}>
            <Typography className="textColor">Sub Option</Typography>
          </Grid>
          <Grid item xs={9}>
            <Switch
              checked={switchCollapsableCheck}
              onChange={handleswitchCollapsableCheck}
              inputProps={{ "aria-label": "controlled" }}
            />
          </Grid>
        </Grid>
        {switchCollapsableCheck ? (
          <>
            <Grid
              container
              className="gridSpecificationContainer"
              spacing={3}
              alignItems="center"
            >
              <Grid item xs={3}></Grid>
              <Grid item xs={9}>
                <Grid container sx={{ alignItems: "center" }} spacing={3}>
                  <Grid item xs={9}>
                    <AutoCompleteMultiSelect
                      label={""}
                      placeholder={"Sub Option"}
                      value={addValue}
                      datas={subOptionDatas}
                      id={2}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <Button
                      onClick={() => {
                        setOpenSubOption(true);
                      }}
                    >
                      + Add Sub Option
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              container
              className="gridSpecificationContainer"
              spacing={3}
              alignItems="center"
            >
              <Grid item xs={3}></Grid>
              <Grid item xs={9}>
                <TableContainer component={Paper}>
                  <Table aria-label="collapsible table">
                    <TableHead>
                      <TableRow>
                        <TableCell>Name</TableCell>
                        <TableCell align="right">Price</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rowsData.map((row) => (
                        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
                          <TableCell component="th" scope="row">
                            {row.suboptionName}
                          </TableCell>
                          <TableCell align="right">
                            {row.subBaseprice}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          </>
        ) : (
          ""
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setopenConfirmaitonModal(true)}
          className="textColor btn"
        >
          Save
        </Button>
      </DialogActions>
      <AddSubOptionDialog
        open={openAddSubOption}
        onClose={() => setOpenSubOption(false)}
        reloadSuboption={ReloadSuboption}
      />
    </Dialog>
  );
}

export default AddOption;
